import React, { useEffect } from 'react';
import '../pages/ViewDataPage/styles.css';

const SuccessNotification = ({ 
  isVisible, 
  message = "Operation completed successfully!", 
  onClose,
  duration = 3000,
  icon = "✓"
}) => {
  useEffect(() => {
    if (isVisible && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose, duration]);

  if (!isVisible) return null;

  return (
    <div className="success-notification">
      <div className="icon">{icon}</div>
      <div className="message">{message}</div>
      {onClose && (
        <button 
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            fontSize: '18px',
            padding: '0 0 0 8px'
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default SuccessNotification;
